import { TableStructure } from "../components/TableStructure";
import { UEVRPLeftMenuList } from "../utils/constants";

const List = [
  {
    fileStoreId: "bff9be59-c46b-49b7-baa9-977d38b724cb",
    label: "EQ SERVIVAL POCKET GUIDE(MHA)",
  },
];

const EQ_Pocket_Guide = () => (
  <TableStructure
    title="EQ SERVIVAL POCKET GUIDE(MHA)"
    heading={false}
    list={List}
    columnNo={1}
    leftMenuList={UEVRPLeftMenuList}
    longMenuList={false}
  />
);

export default EQ_Pocket_Guide;
